realmCommerceApp.controller("OrderListController", OrderListController);

/*@ngInject*/
function OrderListController($window, $uibModal, orders, pagination, apiService, errorsService) {
    var vm = this;
    vm.pagination = {
        busy: false,
        currentPage: 1,
        group: 'all',
        end: false,
        total: 0,
        limit: null,
    };

    vm.pageChanged = pageChanged;
    vm.promptOrderMessage = promptOrderMessage;
    vm.orders = orders;
    vm.order = null;

    activate();

    function activate() {
        vm.orders = orders;
        vm.pagination = pagination;
    }

    function pageChanged() {
        getOrders();
    }

    function getOrders() {
        if (!vm.pagination.busy) {
            vm.pagination.busy = true;
            vm.pagination.rangeStart = (vm.pagination.indexPosition - 1) * vm.pagination.limit;
            apiService.loadOrders(vm.pagination.limit, vm.pagination.rangeStart)
                .then(data => {
                    if (data) {
                        vm.orders = data.orders;
                        vm.pagination = data.pagination;
                    }
                    $window.scrollTo(0, 0);
                })
                .catch(errorsService.errorCallback)
                .finally(() => {
                    vm.pagination.busy = false;
                }
            );
        }
    }

    function promptOrderMessage(order) {
        $uibModal.open({
            template: require('../layout/modal/orderHelpDesk.modal.html'),
            controller: 'OrderController',
            controllerAs: 'vm',
            resolve: {
                orderModel: () => order
            }
        });
    }

}



// WEBPACK FOOTER //
// ./static/js/app/order/order.list.controller.js